var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "rotate(-45 32051.159 -83912.245) scale(31.584)",
    gradientUnits: "userSpaceOnUse",
    x1: -1582,
    x2: -1581,
    y1: -1495.328,
    y2: -1495.328
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c757bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#c757bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#cd5ca9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#e8744f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#f88316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#ff8900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8900"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00afff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#00afff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#5282ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945dff"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientTransform: "rotate(-45 15635.387 -40897.94) scale(15.3946)",
    gradientUnits: "userSpaceOnUse",
    x1: -1582,
    x2: -1581,
    xlinkHref: "#a",
    y1: -1494.622,
    y2: -1494.622
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientTransform: "matrix(7.6364 -7.6366 7.6366 7.6364 23489.887 -665.412)",
    gradientUnits: "userSpaceOnUse",
    x1: -1582,
    x2: -1581,
    xlinkHref: "#a",
    y1: -1494.036,
    y2: -1494.036
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientTransform: "rotate(-45 32051.159 -83912.245) scale(31.584)",
    gradientUnits: "userSpaceOnUse",
    x1: -1582,
    x2: -1581,
    y1: -1495.322,
    y2: -1495.322
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ad4ca4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#ad4ca4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#b25093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#ca6545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#d87213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#de7700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#de7700"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0098de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#0098de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#4771de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8151de"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientTransform: "rotate(-45 15635.387 -40897.94) scale(15.3946)",
    gradientUnits: "userSpaceOnUse",
    x1: -1582,
    x2: -1581,
    xlinkHref: "#b",
    y1: -1494.622,
    y2: -1494.622
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientTransform: "matrix(7.6364 -7.6366 7.6366 7.6364 23489.887 -665.412)",
    gradientUnits: "userSpaceOnUse",
    x1: -1582,
    x2: -1581,
    xlinkHref: "#b",
    y1: -1493.643,
    y2: -1493.643
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H12.05L.639 12h11.34l.053-.054z",
    fill: "url(#c)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24H0zM12.032 11.946l-.053.054h.107z",
    fill: "url(#d)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.05 0H0v12.672V12h.639z",
    fill: "url(#e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.979 12H.639L0 12.672V24z",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.086 12h-.107L0 24h24z",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M.639 12H0v.672z",
    fill: "url(#h)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/kotlin.3729ea11bebba4deed11a53d122ef713.svg";
export { ForwardRef as ReactComponent };